// Переводы vendor'ов для разных языков
(function() {
  'use strict';
  
  // Определяем переводы
  var vendorTranslations = {
    'en': {
      'Heel': 'Heel',
      'cm': 'cm',
      'Heel_1_cm': 'Heel 1 cm',
      'Heel_7_cm': 'Heel 7 cm',
      'Heel_10_cm': 'Heel 10 cm'
    },
    'ru': {
      'Heel': 'Каблук',
      'cm': 'см',
      'Heel_1_cm': 'Каблук 1 см',
      'Heel_7_cm': 'Каблук 7 см',
      'Heel_10_cm': 'Каблук 10 см'
    },
    'it': {
      'Heel': 'Tacco',
      'cm': 'cm',
      'Heel_1_cm': 'Tacco 1 cm',
      'Heel_7_cm': 'Tacco 7 cm',
      'Heel_10_cm': 'Tacco 10 cm'
    }
  };

  // Функция для определения языка
  function getCurrentLanguage() {
    var pathname = window.location.pathname;
    
    if (pathname.indexOf('/ru/') === 0 || pathname === '/ru') {
      return 'ru';
    } else if (pathname.indexOf('/it/') === 0 || pathname === '/it') {
      return 'it';
    }
    return 'en';
  }

  // Функция для перевода vendor'ов
  function translateVendors() {
    var currentLanguage = getCurrentLanguage();
    
    // Ищем все элементы с vendor'ами
    var vendorElements = document.querySelectorAll('.bee-product-vendor a');
    
    for (var i = 0; i < vendorElements.length; i++) {
      var element = vendorElements[i];
      var originalText = element.textContent.trim();
      var vendorKey = originalText.replace(/\s+/g, '_');
      
      // Проверяем, есть ли перевод
      if (vendorTranslations[currentLanguage] && vendorTranslations[currentLanguage][vendorKey]) {
        var translatedText = vendorTranslations[currentLanguage][vendorKey];
        element.textContent = translatedText;
      }
    }
  }

  // Запускаем перевод при загрузке DOM
  function initTranslation() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', translateVendors);
    } else {
      translateVendors();
    }
    
    // Дополнительный запуск через небольшую задержку для AJAX контента
    setTimeout(translateVendors, 1000);
    setTimeout(translateVendors, 3000);
  }

  // Следим за изменениями DOM для динамически загружаемого контента
  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      var hasNewVendors = false;
      
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (node.nodeType === 1) { // Element node
            if (node.querySelector && node.querySelector('.bee-product-vendor')) {
              hasNewVendors = true;
              break;
            }
            if (node.className && node.className.indexOf('bee-product-vendor') !== -1) {
              hasNewVendors = true;
              break;
            }
          }
        }
        if (hasNewVendors) break;
      }
      
      if (hasNewVendors) {
        setTimeout(translateVendors, 200);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Запускаем инициализацию
  initTranslation();
  
  // Дополнительные попытки запуска для надежности
  if (window.addEventListener) {
    window.addEventListener('load', translateVendors);
  } else if (window.attachEvent) {
    window.attachEvent('onload', translateVendors);
  }
})(); 